/*
  NDI Help Center — tab switching, FAQ accordion, and client-side search.
  Ported from the old theme's inline page.help-center script. Vanilla JS, deferred.
  hcToggleAccordion / hcSwitch stay global (called from inline onclick attributes).
*/
function hcToggleAccordion(trigger) {
  var item = trigger.closest('.hc-accordion-item');
  var panel = item.querySelector('.hc-accordion-panel');
  if (item.classList.contains('open')) {
    panel.style.maxHeight = null;
    item.classList.remove('open');
  } else {
    panel.style.maxHeight = panel.scrollHeight + 'px';
    item.classList.add('open');
  }
}

function hcSwitch(tabId, pushState) {
  document.querySelectorAll('.hc-section').forEach(function (el) { el.classList.remove('active'); });
  document.querySelectorAll('.hc-tab-btn').forEach(function (btn) { btn.classList.remove('active'); });
  var section = document.getElementById('hc-' + tabId);
  if (section) section.classList.add('active');
  var btn = document.querySelector('[data-tab="' + tabId + '"]');
  if (btn) btn.classList.add('active');
  if (pushState !== false) window.location.hash = tabId;
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

window.addEventListener('hashchange', function () {
  var hash = window.location.hash.replace('#', '');
  if (hash && document.getElementById('hc-' + hash)) hcSwitch(hash, false);
});

(function () {
  var hash = window.location.hash.replace('#', '');
  if (hash && document.getElementById('hc-' + hash)) hcSwitch(hash, false);
})();

(function () {
  var input = document.getElementById('hc-search-input');
  var results = document.getElementById('hc-search-results');
  var clearBtn = document.getElementById('hc-search-clear');
  if (!input || !results) return;

  var sectionMap = {
    'hc-faq': { tab: 'faq', label: 'FAQ' },
    'hc-how-to-pay': { tab: 'how-to-pay', label: 'Payment Methods' },
    'hc-return-policy': { tab: 'return-policy', label: 'Return & RMA Policy' },
    'hc-shipping-policy': { tab: 'shipping-policy', label: 'Shipping Information' },
    'hc-backorder-policy': { tab: 'backorder-policy', label: 'Backorder Policy' },
    'hc-privacy-policy': { tab: 'privacy-policy', label: 'Privacy & Security' }
  };

  function buildIndex() {
    var entries = [];
    Object.keys(sectionMap).forEach(function (sectionId) {
      var el = document.getElementById(sectionId);
      if (!el) return;
      var nodes = el.querySelectorAll('h2, h3, h4, p, li div, .hc-info-card .title, .hc-info-card p');
      nodes.forEach(function (node) {
        var text = node.textContent.trim();
        if (text.length < 5) return;
        entries.push({
          text: text,
          truncated: text.length > 100 ? text.substring(0, 100) + '…' : text,
          sectionId: sectionId,
          element: node
        });
      });
    });
    return entries;
  }

  var index = buildIndex();

  function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlightText(str, query) {
    var re = new RegExp('(' + escapeRegex(query) + ')', 'gi');
    return str.replace(re, '<mark>$1</mark>');
  }

  function doSearch(query) {
    query = query.trim();
    clearBtn.style.display = query ? 'flex' : 'none';

    if (query.length < 2) {
      results.classList.remove('visible');
      results.innerHTML = '';
      return;
    }

    var lower = query.toLowerCase();
    var grouped = {};
    var count = 0;

    index.forEach(function (entry) {
      if (count >= 20) return;
      if (entry.text.toLowerCase().indexOf(lower) === -1) return;
      var sid = entry.sectionId;
      if (!grouped[sid]) grouped[sid] = [];
      grouped[sid].push(entry);
      count++;
    });

    if (count === 0) {
      results.innerHTML = '<div class="hc-search-empty">No results for "' + query.replace(/</g, '&lt;') + '"</div>';
      results.classList.add('visible');
      return;
    }

    var html = '';
    Object.keys(grouped).forEach(function (sid) {
      var info = sectionMap[sid];
      html += '<div class="hc-search-group-label">' + info.label + '</div>';
      grouped[sid].forEach(function (entry) {
        html += '<button class="hc-search-item" data-tab="' + info.tab + '" data-section="' + sid + '">'
          + highlightText(entry.truncated.replace(/</g, '&lt;').replace(/>/g, '&gt;'), query)
          + '</button>';
      });
    });

    results.innerHTML = html;
    results.classList.add('visible');

    results.querySelectorAll('.hc-search-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-tab');
        var sid = btn.getAttribute('data-section');
        results.classList.remove('visible');

        var targetSection = document.getElementById(sid);
        if (targetSection) targetSection.classList.add('no-anim');

        hcSwitch(tab);

        var matchEntry = grouped[sid] && grouped[sid].find(function (e, idx) {
          var items = results.querySelectorAll('[data-section="' + sid + '"]');
          var localIdx = Array.prototype.indexOf.call(items, btn);
          return idx === localIdx;
        });

        if (matchEntry && matchEntry.element) {
          var el = matchEntry.element;
          el.classList.remove('hc-highlight-flash', 'hc-fade-out');
          void el.offsetWidth;
          requestAnimationFrame(function () {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.classList.add('hc-highlight-flash');
            setTimeout(function () { el.classList.add('hc-fade-out'); }, 1500);
          });
        }

        setTimeout(function () {
          if (targetSection) targetSection.classList.remove('no-anim');
        }, 50);
      });
    });
  }

  var debounceTimer;
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { doSearch(input.value); }, 200);
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.style.display = 'none';
    results.classList.remove('visible');
    results.innerHTML = '';
    input.focus();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hc-search-box')) {
      results.classList.remove('visible');
    }
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && results.innerHTML) {
      results.classList.add('visible');
    }
  });
})();
